import { AnyIfEmpty } from 'react-redux';
import { INVITE_STAFF_FAILURE, INVITE_STAFF_REQUEST, INVITE_STAFF_SUCCESS, STAFF_LIST_FAILURE, STAFF_LIST_REQUEST, STAFF_LIST_SUCCESS } from '../constants/invitedStaff.constants';


const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
    staffLoading: false,
    staffData: [],
    staffError: ''
}

export const invitedStaffReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case INVITE_STAFF_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };

        case INVITE_STAFF_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                errorMsg: ''
            };

        case INVITE_STAFF_FAILURE:
            return {
                ...state,
                data: [],
                loading: false,
                errorMsg: action.payload,
            };

        case STAFF_LIST_REQUEST:
            return {
                ...state,
                staffLoading: true,
                staffData: [],
                staffError: ''
            };

        case STAFF_LIST_SUCCESS:
            return {
                ...state,
                staffLoading: false,
                staffData: action.payload,
                staffError: ''
            }
        case STAFF_LIST_FAILURE:
            return {
                ...state,
                staffLoading: false,
                staffData: [],
                staffError: action.payload
            };

        default: return state;
    }
}